import { Button, Typography } from 'antd'

interface IProps {
  inverse?: boolean
  code?: string
  header: string
  paragraph: string
  button?: boolean
  buttonLabel?: string
  buttonAction?: () => void
  dataTestId?: string
}

function Errors(props: IProps) {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full px-4" data-testid={`error_container_${props.dataTestId}`}>
      {props.code && (
        <Typography.Title
          data-testid="error_container_status"
          className={`text-8xl my-0 text-center ${props.inverse ? 'text-warning' : 'text-primary'}`}
          level={5}
        >
          {props.code}
        </Typography.Title>
      )}
      <Typography.Title
        data-testid="error_container_title"
        className={`text-xl lg:text-xl mt-2 mb-0 text-center ${
          props.inverse ? 'text-white' : 'text-primary'
        }`}
        level={5}
      >
        {props.header}
      </Typography.Title>
      <Typography.Paragraph
        data-testid="error_container_description"
        className={`text-base font-normal text-center ${
          props.inverse ? 'text-white' : 'text-gray-600'
        }`}
      >
        {props.paragraph}
      </Typography.Paragraph>
      {props.button && props.buttonAction && props.buttonLabel && (
        <Button
          data-testid="error_container_action"
          onClick={props.buttonAction}
          htmlType="button"
          className={`mt-2 rounded-lg px-4 text-md font-bold no-underline w-auto ${
            props.inverse
              ? 'bg-warning-700 text-sm text-dark hover:bg-warning-800 '
              : 'bg-danger-600 text-white hover:bg-danger-700 '
          }`}
          shape="round"
        >
          {props.buttonLabel}
        </Button>
      )}
    </div>
  )
}

export default Errors
